import { gql } from '@apollo/client';

export const DistributionOddsFragment = gql`
  fragment DistributionOddsFragment on DistributionOdds {
    tier
    value
    displayValue
  }
`;
